import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.casos-de-exito.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/casos-de-exito")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
